import { render, staticRenderFns } from "./ExpenseCategory.vue?vue&type=template&id=37724552&"
import script from "./ExpenseCategory.vue?vue&type=script&lang=js&"
export * from "./ExpenseCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports